export default __webpack_public_path__ + "static/media/infusion.138b3bb5.jpg";